module.exports = __webpack_public_path__ + "static/img/jzfbtLogoN.9afd416.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jzfbtLogoN.jpg
// module id = 1rfv
// module chunks = 2